import { render, staticRenderFns } from "./row.vue?vue&type=template&id=3b5d8146&scoped=true&"
import script from "./row.vue?vue&type=script&lang=ts&"
export * from "./row.vue?vue&type=script&lang=ts&"
import style0 from "./row.vue?vue&type=style&index=0&id=3b5d8146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d8146",
  null
  
)

export default component.exports